import { Col, message, Row, Space, Form as FormInitial } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import cobroPdf from "../../../../Pdf/cobroPdf";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import cobroFernandoPdf from "../../../../Pdf/cobroFernandoPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class MandarCorreoPago extends Component {
  formRef = React.createRef();
  iframeRef = React.createRef();
  urlPdf = null;
  state = {
    loading: false,
    loadingEstado: false,
    pdf: null,
    clienteId: null,
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  componentWillUnmount() {
    if (this.urlPdf) URL.revokeObjectURL(this.urlPdf);
  }
  // `pdf.open` navega el iframe con `location.href` y eso agrega una entrada al historial:
  // después, el `history.goBack()` de la pantalla sólo regresaba el iframe. Con
  // `location.replace` el PDF se muestra sin dejar entrada.
  mostrarPdf(pdf) {
    pdf.getBlob((blob) => {
      const iframe = this.iframeRef.current;
      if (!iframe?.contentWindow) return;
      if (this.urlPdf) URL.revokeObjectURL(this.urlPdf);
      this.urlPdf = URL.createObjectURL(blob);
      iframe.contentWindow.location.replace(this.urlPdf);
    });
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "pagos/datosPago",
        { pagoId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data?.correosEnvio?.length > 0) {
          this.formRef.current.setFieldsValue({ correosEnvio: res.data.correosEnvio })
        }
        const pdf = pdfMake.createPdf((this.props.empresaId.toString() === '677c1e57f38e06c3032974fb') ? cobroFernandoPdf(res.data) : cobroPdf(res.data));

        this.setState(
          {
            loading: false,
            pdf: pdf,
            clienteId: res.data.clienteId || null,
          },
          () => {
            this.mostrarPdf(pdf);
          }
        );

      });
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    if (values?.correosEnvio?.length > 0) {
      this.setState({ loading: true });
      axios
        .post(
          "pagos/enviarPago",
          { ...values, pagoId: this.props.id, empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Pago enviado");
            this.formRef.current.resetFields();
            this.cerrarMandarCorreoPago();
          } else if (res.data.success === 1) {
            // El servidor dice por qué no se pudo (correo mal formado, sin PDF, cuenta
            // de envío sin configurar). El texto fijo escondía todo eso.
            message.error(res.data.message || "No se pudo enviar el pago a ese correo");
          } else {
            message.error(res.data.message || "Sucedio un error y no se pudo enviar");
          }
        });
    } else {
      message.info('Proporcione al menos un correo de envio')
    }
  }
  async enviarEstadoCuenta(sinRemisiones) {
    const values = this.formRef.current.getFieldsValue();
    if (!values?.correosEnvio?.length) {
      message.info('Proporcione al menos un correo de envío');
      return;
    }
    if (!this.state.clienteId) {
      message.error('No se encontró el cliente');
      return;
    }
    this.setState({ loadingEstado: true });
    await axios
      .post(
        "recordatoriosProgramados/enviarRecordatorioIndividual",
        {
          correosEnvio: values.correosEnvio,
          clienteId: this.state.clienteId,
          empresaId: this.props.empresaId,
          usuarioId: this.props.usuarioId,
          sinRemisiones: sinRemisiones,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Estado de cuenta enviado correctamente.");
        } else {
          message.warning(res.data.message || "No se pudo enviar el estado de cuenta.");
        }
      })
      .catch((error) => {
        console.error(error);
        message.error("Error al enviar el estado de cuenta.");
      })
      .finally(() => {
        this.setState({ loadingEstado: false });
      });
  }
  descargarComplemento() {
    axios
      .post(
        "pagos/datosPago",
        { pagoId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {

        const dataSat = res.data.respuestaComplemento.dataSat
        const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Nombre + ' )'

        const pdf = cobroPdf(res.data)

        pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf")
      });
  }
  cerrarMandarCorreoPago() {
    this.props.cerrarMandarCorreoPago();
    this.formRef.current.resetFields()
  }
  render() {
    return (
      <ModalItem
        title="Vista previa"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarMandarCorreoPago.bind(this)}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="mandarCorreoComplemento"
          layout
          width={700}
          onCancel={this.cerrarMandarCorreoPago.bind(this)}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List
            name="correosEnvio"
            initialValue={[{ correo: '' }]}
          >
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label='Correo'
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem style={{ width: '100%' }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: 'center' }}>
                        <MinusCircleOutlined
                          onClick={() => remove(name)}
                        />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ?
                  <div style={{ textAlign: 'center', marginTop: '5px' }}>
                    <ButtonItem
                      type="primary"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Agregar
                    </ButtonItem>
                  </div>
                  : null}
              </>
            )}
          </FormInitial.List>
          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <ButtonItem
                type="primary"
                blanco={true}
                onClick={this.descargarComplemento.bind(this)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Descargar
              </ButtonItem>
              <ButtonItem
                type="primary"
                azul
                loading={this.state.loadingEstado}
                onClick={() => this.enviarEstadoCuenta(false)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Estado de cuenta
              </ButtonItem>
              <ButtonItem
                type="primary"
                naranja
                loading={this.state.loadingEstado}
                onClick={() => this.enviarEstadoCuenta(true)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Estado sin remisiones
              </ButtonItem>
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Mandar Correo
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrarMandarCorreoPago.bind(this)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>
        <iframe
          ref={this.iframeRef}
          title={"complemento"}
          style={{ width: "100%", height: "100vh" }}
          id="pagoPdf"
          name="pagoPdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    usuarioId: state.user.usuarioId,
  };
};

export default connect(mapStateToProps)(MandarCorreoPago);
